const portraits = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_20.png",
  alt: "Portrait 20"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_21.png",
  alt: "Portrait 21"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_22.png",
  alt: "Portrait 22"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_23.png",
  alt: "Portrait 23"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_24.png",
  alt: "Portrait 24"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_25.png",
  alt: "Portrait 25"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_26.png",
  alt: "Portrait 26"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_18.png",
  alt: "Portrait 18"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_19.png",
  alt: "Portrait 19"
}];
const allPortraits = [...portraits, ...portraits];
export default function PodcastMarquee() {
  return <section style={{
    backgroundColor: "#F5F4F2",
    position: "relative",
    overflow: "hidden"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&display=swap');

        :root {
          --marquee-item-width: 200px;
          --marquee-item-height: 240px;
          --marquee-items: 18;
          --marquee-duration: 40s;
        }

        .podcast-marquee-track {
          display: flex;
          height: var(--marquee-item-height);
          position: relative;
          overflow: hidden;
          mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0));
          -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0, 0, 0, 0));
        }

        .podcast-marquee-inner {
          display: flex;
          align-items: center;
          gap: 49px;
          animation: marquee-go var(--marquee-duration) linear infinite;
          will-change: transform;
          padding-left: 0;
        }

        @keyframes marquee-go {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .podcast-marquee-inner:hover {
          animation-play-state: paused;
        }

        .marquee-portrait {
          flex-shrink: 0;
          width: 200px;
          height: 200px;
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          overflow: hidden;
          position: relative;
        }

        .marquee-portrait:nth-child(4n) {
          border-radius: 50% 50% 50% 50% / 40% 60% 60% 40%;
          border-top-right-radius: 1rem;
        }

        .marquee-portrait:nth-child(4n+1) {
          border-bottom-right-radius: 1rem;
        }

        .marquee-portrait:nth-child(4n+2) {
          border-bottom-left-radius: 1rem;
        }

        .marquee-portrait:nth-child(4n+3) {
          border-top-left-radius: 1rem;
        }

        .marquee-portrait img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .podcast-marquee-red-border {
          height: 5px;
          background-color: #F73C4A;
          width: 100%;
        }
      `}</style>

      <div className="podcast-marquee-track" style={{
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(33, 33, 31)",
      fontFamily: "Switzer, sans-serif",
      animation: "none 0s ease 0s 1 normal none running",
      display: "flex",
      position: "relative",
      overflow: "hidden",
      paddingTop: "20px",
      paddingBottom: "20px"
    }}>
        <div className="podcast-marquee-inner">
          {allPortraits.map((portrait, index) => <div key={index} className="marquee-portrait">
              <img src={portrait.src} alt={portrait.alt} className="w-full h-auto" />
            </div>)}
        </div>
      </div>

      
    </section>;
}